const enum FeatureFlags {
  SHOW_CALL_PLAN_TAB = "SHOW_CALL_PLAN_TAB",
  SHOW_NEW_ACTIVITY_LIBRARY = "SHOW_NEW_ACTIVITY_LIBRARY",
}

export const FeatureFlagDefaults: Record<FeatureFlags, boolean> = {
  [FeatureFlags.SHOW_CALL_PLAN_TAB]: false,
  [FeatureFlags.SHOW_NEW_ACTIVITY_LIBRARY]: false,
};

export default FeatureFlags;
